import { ReactElement } from 'react';
import { Loading } from '../shared/loading/Loading';
import styles from './ProductTile.module.scss';

export function ProductTileShimmer() : ReactElement {
  return (
    <div className={`${styles.product_tile} ${styles.loading_product_tile}`}>
      <Loading className={styles.product_image} />
      <div className={styles.loading_favorite_button} />
      <div className={styles.bottom_style}>
        <Loading className={styles.title} width={246} height={22} />
        <Loading className={styles.sub_title} width={233} height={12} />
        <Loading className={styles.sub_title} width={233} height={12} />
        <div className={styles.product_tag_quantity_selector_container}>
          <div className={styles.product_tag_buttons_container}>
            <Loading height={21} width={76} radius={40} />
            <Loading height={21} width={76} radius={40} />
          </div>
        </div>
      </div>
    </div>
  );
}
